import React, { useState } from "react";
import { buildApiUrl } from "../config/api";

const GoalForm = ({ onGoalAdded }) => {
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        priority: "medium",
        category: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setError("");
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!formData.title.trim()) {
            return;
        }

        setLoading(true);
        setError("");

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(buildApiUrl("/api/goals"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    title: formData.title.trim(),
                    description: formData.description.trim() || null,
                    priority: formData.priority,
                    category: formData.category.trim() || null,
                    is_completed: true
                })
            });

            const data = await response.json();

            if (response.ok) {
                onGoalAdded(data.goal);
                setFormData({
                    title: "",
                    description: "",
                    priority: "medium",
                    category: ""
                });
            } else {
                setError(data.error || "记录失败，请稍后再试");
            }
        } catch (err) {
            setError("网络异常，请稍后重试。");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="workspace-card goal-composer" id="goal-composer">
            <header className="goal-composer__header">
                <h2>记录新的成果</h2>
                <p>描述关键成果、优先级与分类，DoneLog 会在时间线上展示并辅助复盘。</p>
            </header>

            <form className="goal-composer__form" onSubmit={handleSubmit}>
                {error && <div className="goal-composer__error">{error}</div>}

                <div className="goal-composer__field">
                    <label className="goal-composer__label" htmlFor="goal-title">成果标题</label>
                    <input
                        id="goal-title"
                        type="text"
                        name="title"
                        className="goal-composer__input"
                        placeholder="例如：上线 2.0 版本的官网"
                        value={formData.title}
                        onChange={handleInputChange}
                        disabled={loading}
                        required
                    />
                </div>

                <div className="goal-composer__grid">
                    <div className="goal-composer__field">
                        <label className="goal-composer__label" htmlFor="goal-description">成果细节</label>
                        <textarea
                            id="goal-description"
                            name="description"
                            className="goal-composer__textarea"
                            placeholder="补充背景、亮点或复盘心得（选填）"
                            value={formData.description}
                            onChange={handleInputChange}
                            disabled={loading}
                        />
                    </div>
                    <div className="goal-composer__field">
                        <label className="goal-composer__label" htmlFor="goal-priority">优先级</label>
                        <select
                            id="goal-priority"
                            name="priority"
                            className="goal-composer__select"
                            value={formData.priority}
                            onChange={handleInputChange}
                            disabled={loading}
                        >
                            <option value="high">高优先级</option>
                            <option value="medium">中优先级</option>
                            <option value="low">低优先级</option>
                        </select>
                    </div>
                    <div className="goal-composer__field">
                        <label className="goal-composer__label" htmlFor="goal-category">分类标签</label>
                        <input
                            id="goal-category"
                            type="text"
                            name="category"
                            className="goal-composer__input"
                            placeholder="例如：产品、学习、个人成长"
                            value={formData.category}
                            onChange={handleInputChange}
                            disabled={loading}
                        />
                    </div>
                </div>

                <div className="goal-composer__footer">
                    <span className="goal-composer__hint">技巧：写下完成的关键结果，未来复盘时会更有素材。</span>
                    <button
                        type="submit"
                        className="btn primary"
                        disabled={loading || !formData.title.trim()}
                    >
                        {loading ? "保存中..." : "保存成果"}
                    </button>
                </div>
            </form>
        </section>
    );
};

export default GoalForm;
